module.exports = function() {
  var result = {};

  for (var prop in this) {
    if (!this.hasOwnProperty(prop) || prop.match(/^(?:include|contains|reverse|join|map|wrap)$/)) continue;
    result[prop] = this[prop];
  }

  return result;
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/exports.js
// module id = 1617
// module chunks = 0